import styled from 'styled-components';

import FlexColumn from '@ui/atoms/FlexColumn';

import { BreakpointTypes, SpacingTypes } from '@folx-types/theme';

import theme from '@theme/FolxTheme';

export interface IFlexColToRow {
	breakpoint?: BreakpointTypes;
	gap?: SpacingTypes;
	initialLayout?: 'column' | 'row';
}

export default styled.div<IFlexColToRow>`
	display: flex;
	flex-flow: ${({ initialLayout = 'column' }) => initialLayout};
	gap: ${({ gap }) => gap && theme.spacing![gap]};

	@media ${({ breakpoint = 'laptop' }) => theme.responsive.breakpoints[breakpoint]} {
		flex-flow: ${({ initialLayout = 'column' }) => (initialLayout === 'column' ? 'row' : 'column')};
	}
`;
